import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from '../../../routePaths';
import WarehouseToolbar from '../../../modules/warehouse/components/WarehouseToolbar/WarehouseToolbar';
import { useWarehousesScope } from '../../../modules/warehouse/providers/WarehouseScopeProvider';
import { DeductionListsPage } from '../../../modules';

const DeductionLists = () => {
    const { warehouses } = useWarehousesScope();

    if (warehouses.length === 0) {
        return <Redirect to={routePaths.warehouses} />;
    }

    return (
        <>
            <WarehouseToolbar />
            <DeductionListsPage />
        </>
    );
};

export default DeductionLists;
